import { render, staticRenderFns } from "./SidebarEditAddress.vue?vue&type=template&id=f564f1f0&scoped=true"
import script from "./SidebarEditAddress.vue?vue&type=script&lang=js"
export * from "./SidebarEditAddress.vue?vue&type=script&lang=js"
import style0 from "./SidebarEditAddress.vue?vue&type=style&index=0&id=f564f1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f564f1f0",
  null
  
)

export default component.exports